import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Icon, InputNumber, Upload, Popconfirm } from 'antd'
import { infoRequired, validateCaracteresUpload } from '../../../utils/validators'
import { gerarAporte } from '../../../redux-flow/actions/contratos'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import attach from '../../../images/attach.png'
import moment from 'moment'

const { Dragger}  = Upload

class FormAporte extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            valorInput: 0,
            disabled: false,
            showButton: false,
            error: {},
            message: '',
            isClicked: 0
        }
    }

    // beforeUpload = (type) => file => {
    //     const specialChars = /^[a-zA-Z0-9_-]+$/
    //     const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
    //     if (specialChars.test(fileWithoutExtension) === false) {
    //         this.setState({ error: { type: 'specialChars', message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' }, isClicked: type })
    //     } else {
    //         const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
    //         if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
    //             this.setState({ error: { type: 'typeOfFile', message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' }, isClicked: type })
    //         } else {
    //             this.setState({
    //                 file,
    //                 error: {}
    //             })
    //         }
    //     }
    //     return false
    // }

    beforeUpload = (type) => file => {
        const specialChars = /^[a-zA-Z0-9_-\d ]+$/
        const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        const fileSize = file.size
        if (specialChars.test(fileWithoutExtension) === false) {
            this.setState({ error: { type: 'specialChars', message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' }, isClicked: type })
        } else if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
            this.setState({ error: { type: 'typeOfFile', message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' }, isClicked: type })
        } else {
            if (fileSize > 5242880) { // 5MB in bytes
                this.setState({ error: { type: 'fileSize', message: 'Por favor, envie arquivos de até 5MB.' }, isClicked: type})
            } else {
                this.setState({
                    arquivoContrato: file.name, 
                    file: file,
                    error: {}
                })
            }
        }
        return false
    }

    changeInput = e => {
        this.setState({
            valorInput: e
        })
    }

    refreshPage() {
        setTimeout(function(){
            window.location.reload()
        }, 5000)
    }

    handleClick(e) {
        console.log("stop pop", e);
        e.preventDefault()
        if (this.state.disabled) {
            return
        }
        this.setState({ disabled: true }) 
    }

    render() {
        const { form, handleSubmit, idContrato, tipo, logMessage, isLoading, userId } = this.props
        let success =  this.props.success


        return success ? (
            <div className="finishedSignup" onLoad={this.refreshPage()}>
                <div>
                    <h2 className="text-dark">Aporte requisitado!</h2>
                    <p className="text-dark">
                        Sucesso! Seu aporte foi requisitado e está sendo processado! <br />
                    </p>
                </div>
            </div>
        ) : (
            <Form className="formContrato" layout="vertical" onSubmit={handleSubmit(form, this.state.file, idContrato, tipo, userId)}>
                
                {logMessage && <Form.Item>
                    <div class="alert alert-danger fade show notificacao-status">
                        <p className="mb-0">{logMessage}</p>
                    </div>
                </Form.Item>}
                <div style={{ textAlign: 'center' }}>
                    {isLoading && <Form.Item>
                        <Icon type="loading" />
                    </Form.Item>}
                </div>
                <Form.Item label="1. Insira o valor do aporte">
                <div className='d-flex align-items-center justify-content-center'>
                    <h6 className="mb-0 mt-1">R$</h6>
                    {form.getFieldDecorator('valor', {
                    initialValue: tipo === 6 ? 500 : 200,
                    rules: [ infoRequired ]
                            })(
                    <InputNumber
                        className="ml-2"
                        style={{ width: '100%' }}
                        min={tipo === 6 ? 500 : 200}
                        precision={2}
                        step={0.01}
                        onChange={e => this.changeInput(e)}
                    />
                )}
                </div>
                </Form.Item>
                    <div className="limiterDeposito mobile">
                        <h6 className="tx-light-pink">2. Faça o depósito para a conta <span className="tx-pink">{process.env.REACT_APP_NAME}</span></h6>
                        <div className="limiterBancoInfo">
                            <label className="tx-light-pink">Banco: </label><br />
                            <label className="text-white">{tipo === 6 ? '336 - C6 Bank S.A' : '260 - Nu Pagamentos S.A'}</label>
                        </div>
                        <div className="limiterBancoInfo">
                            <label className="tx-light-pink">Nome: </label><br />
                            <label className="text-white">Lemon Empreendimentos Eireli</label>
                        </div>
                        <div className="limiterBancoInfo">
                            <label className="tx-light-pink">CNPJ: </label><br />
                            <label className="text-white">06.979.704/0001-34</label>
                        </div>
                        <div className="limiterBancoInfo">
                            <label className="tx-light-pink">Agência: </label><br />
                            <label className="text-white">0001</label>
                        </div>
                        <div className="limiterBancoInfo">
                            <label className="tx-light-pink">Conta: </label><br />
                            <label className="text-white">{tipo === 6 ? '2099432-0' : '11378755-7'}</label>
                        </div>
                    </div>                            
                    <Form.Item className='meusDados'>
                        <label className="subTitle tx-light-pink">3. Comprovante de depósito</label>
                        <p className="tx-darker"><FontAwesomeIcon className="mr-2" icon={faInfoCircle}></FontAwesomeIcon>Por favor, envie seu comprovante de depósito. O nome do arquivo deve conter até 15 caractéres.</p>
                        <Dragger
                            required
                            beforeUpload={this.beforeUpload(1)}
                            onRemove={() => this.setState({ file: '' })}
                            style={{ paddingBottom: '20px' }}
                        >
                            <label className="tx-pink mb-0"><img alt="Ícone upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                        </Dragger>
                        {this.state.isClicked === 1 ?
                            <>
                                <br />
                                <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'specialChars' ? this.state.error.message : ''}</small>
                                <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'fileSize' ? this.state.error.message : ''}</small>
                                <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'typeOfFile' ? this.state.error.message : ''}</small><br />
                            </> : ''
                        }
                    </Form.Item>
                <Form.Item>
                    {!isLoading ?
                    <Popconfirm
                        title={<div><label>Tem certeza que deseja realizar este aporte?</label><br /><label>Contrato: {tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA')}</label><br /><label>Valor: R${this.state.valorInput === 0 ? (tipo === 6 ? 500 : 200) : this.state.valorInput}</label><br /><label>Data: {moment().format("DD/MM/YYYY")}</label></div>}
                        onConfirm={handleSubmit(form, this.state.file, idContrato, tipo, userId)}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Button 
                            disabled={isLoading || this.state.error.type === 'specialChars' || this.state.error.type === 'typeOfFile' || this.state.error.type === 'fileSize'} 
                            className="btnGraficoModal" 
                            htmlType="submit" 
                            style={{ width: '100%', display: 'inline'}}
                            block
                        >
                            Enviar 
                        </Button>
                    </Popconfirm> :
                    <Button className="btnGraficoDisabled" style={{ width: '100%' }}>Enviando...</Button> }
                </Form.Item>
            </Form>
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    userid: state.login.userid
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, comprovante, idContrato, tipo, userId) => e => {
        e.preventDefault()
        dispatch(gerarAporte(form, comprovante, idContrato, tipo, userId))
    }
})

export default Form.create({ name: 'create-aporte' })(
    connect(mapStateToProps, mapDispatchToProps)(FormAporte)
)